import { createSlice } from '@reduxjs/toolkit'
import { UpdateSession } from '../services/last-state-service';
import { SessionId } from '../constants/localStorageKeys';

export const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    value: '',
  },
  reducers: {
    setSession: (state, action) => {
        state.value = action.payload;
        UpdateSession({sessionId: action.payload});
    },
    resetSession: (state) => {
        state.value = '';
        localStorage.removeItem(SessionId);
    },
  },
})

export const { setSession, resetSession } = sessionSlice.actions

export const selectSession = (state) => state.session.value

export default sessionSlice.reducer